<template>
<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-color-siliflow`]" width="1em" height="1em" v-bind="$attrs"><path d="M15.3049 4.17383H8.34759C7.96299 4.17383 7.65244 4.48585 7.65244 4.86898V6.95587C7.65244 7.34044 7.34186 7.65102 6.95728 7.65102H0.695146C0.310562 7.65102 0 7.96305 0 8.34618V11.1297C0 11.5142 0.312014 11.8248 0.695146 11.8248H7.65244C8.03701 11.8248 8.34759 11.5128 8.34759 11.1297V9.04278C8.34759 8.65817 8.65814 8.34762 9.04272 8.34762H15.3049C15.6895 8.34762 16 8.0356 16 7.65247V4.86898C16 4.4844 15.688 4.17383 15.3049 4.17383Z" :fill="useCurrentColor ? 'currentColor' : '#6E29F5'"/></svg>
</template>
<script>

export default {
  name: 'IconColorSiliflow',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
